var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://elite-api.thriftyspends.com';
    service.VP_URL = 'https://verifyme.elitefundusa.com/loan-application-status';
    service.BACK_URL = 'https://elitefundusa.com';
    
} else {
    service.API_URL = 'https://elite-api.thriftyspends.com';
    service.VP_URL = 'https://verifyme.elitefundusa.com/loan-application-status';
    service.BACK_URL = 'https://elitefundusa.com';
}

export default service;
